export const getMediaType = (type: string): string => {
  if (type.startsWith('image/')) return 'IMAGE';
  if (type.startsWith('video/')) return 'VIDEO';
  if (type === 'application/pdf') return 'DOCUMENT';
  if (type.startsWith('audio/')) return 'SOUND';
  return 'UNKNOWN'; // fallback for unsupported types
};
